export const RU_APP_CODE = '3';
export const INTL_APP_CODE = 'yango';
export const RTL_LANGUAGES = ['ar'];
export const RU_APP_CODE_COUNTRIES = ['ru', 'by', 'ge', 'md', 'kz', 'kg', 'rs', 'uz', 'am'];
